import { HTTPClient } from '../utils/request'

// eslint-disable-next-line no-undef
const baseURL = `${process.env.VUE_APP_CHAT_API_URL}/priority`

export default {
  prioritize: ({ params, payload }) => HTTPClient.post(`/${params._id}`, payload, { baseURL }),
  gr: ({ params }) => HTTPClient.post(`/${params._id}/gr`, {}, { baseURL }),
  assign: ({ params }) => HTTPClient.put(`/${params._id}`, {}, { baseURL }),
  finish: ({ params, payload }) => HTTPClient.put(`/${params._id}/finish`, payload, { baseURL }),
  block: ({ params, }) => HTTPClient.put(`/${params._id}/${params.status}`, {}, { baseURL }),
  assigned: ({ query }) => HTTPClient.get(`/driver/assign${query}`),
  save: ({ params, payload }) => HTTPClient.put(`/${params._id}/notes`, payload, { baseURL }),
}
